import {inject} from "@angular/core";
import {catchError, throwError} from "rxjs";
import {HttpInterceptorFn} from '@angular/common/http';

import {ToastrService} from "ngx-toastr";

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const toastrService: ToastrService = inject(ToastrService);

  return next(req).pipe(
    catchError((error) => {
      if (error.status !== 404) {
        if (error.status === 401) {
          toastrService.error('Необходим е вход в системата.');
        } else if (error.status === 403) {
          toastrService.error('Нямате необходимите права за достъп.');
        } else if (error.status === 417) {
          toastrService.error(error?.error?.message || 'Невалидна заявка.');
        } else {
          toastrService.error('Възникна неочаквана грешка. Опитайте отново.');
        }
      }
      return throwError(() => error);
    })
  );
};
